export default __webpack_public_path__ + "static/media/fancy-kermit.f7d9a8eb.jpeg";